import React from "react";
import { IonSkeletonText } from "@ionic/react";

const ResearchExpandCardSkeleton = () => (
  <div className="border-b-[1px] border-[#ffffff33] pb-4">
    <div className="p-4 rounded-lg ">
      <div className="flex items-center gap-2 mb-2">
        <IonSkeletonText animated style={{ width: '20px', height: '20px' }} />
        <IonSkeletonText animated style={{ width: '120px', height: '20px' }} />
        <div className="ml-auto">
          <IonSkeletonText animated style={{ width: '60px', height: '16px' }} />
        </div>
      </div>
      <IonSkeletonText animated style={{ width: '90%', height: '40px', marginTop: '24px' }} />
    </div>
  </div>
);

const SimilarPlayersSkeleton = () => (
  <div className="flex flex-col -ml-3 border-b-[0.6px] border-[#ffffff33]">
    <div className="p-3 pb-5 flex gap-4 items-center rounded-2xl">
      <div className="relative w-[54px] h-[47.84px] xl:w-[67px] xl:h-[60.84px] md:w-[60px] md:h-[50.84px]">
        <IonSkeletonText animated style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
      </div>
      <div className="w-[70%] ml-4">
        <IonSkeletonText animated style={{ width: '80%', height: '24px', marginBottom: '8px' }} />
        <IonSkeletonText animated style={{ width: '60%', height: '16px' }} />
      </div>
      <IonSkeletonText animated style={{ width: '20px', height: '20px', position: 'absolute', right: '32px' }} />
    </div>
  </div>
);

const ResearchOverviewSkeleton: React.FC = () => (
  <>
    <div className="mt-5 flex flex-col">
      {[1, 2, 3, 4].map((_, index) => (
        <ResearchExpandCardSkeleton key={index} />
      ))}
    </div>

    <div className="mt-7 pb-5">
      <div className="flex items-center text-white mb-4 sm:mb-5 md:mb-6 lg:mb-7">
        <IonSkeletonText animated style={{ width: '20px', height: '20px', marginRight: '8px' }} />
        <IonSkeletonText animated style={{ width: '150px', height: '32px' }} />
      </div>
      {[1, 2, 3].map((_, index) => (
        <SimilarPlayersSkeleton key={index} />
      ))}
    </div>
  </>
);

export default ResearchOverviewSkeleton;
